<template>
  <div class="order-button" style="display: inline">
    <b-button :pill="pill" :block="block" :variant="variant" @click.prevent="$bvModal.show(name)">{{ title }}</b-button>
    <b-modal :id="name" hide-footer :title="title">
      <b-form @submit.prevent="submitCallme">
        <div class="d-block">
          <p class="text-center">
            <img src="/img/order.svg" style="height: 120px" />
          </p>
          <h4 class="text-center">Оставьте номер телефона или email:</h4>
          <p class="text-danger">{{ errors }}</p>
          <b-input-group class="mt-3">
            <b-input-group-prepend is-text>
              <b-icon icon="person"></b-icon>
            </b-input-group-prepend>
            <b-form-input id="callmename" v-model="callme.name" required placeholder="Введите ваше имя"></b-form-input>
          </b-input-group>

          <b-input-group class="mt-3">
            <b-input-group-prepend is-text> <b-icon icon="envelope"></b-icon> </b-input-group-prepend
            ><b-form-input id="callmeemail" v-model="callme.email" type="email" placeholder="Введите email"></b-form-input>
          </b-input-group>

          <b-input-group class="mt-3">
            <b-input-group-prepend is-text>
              <b-icon icon="phone"></b-icon>
            </b-input-group-prepend>
            <b-form-input id="callmephone" v-model="callme.phone" placeholder="Введите номер телефона"></b-form-input>
          </b-input-group>
        </div>
        <b-button type="submit" class="mt-3" block>Отправить</b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import api from "../api"

export default {
  name: "OrderButton",
  props: {
    name: String,
    title: String,
    icon: String,
    variant: String,
    pill: Boolean,
    block: Boolean,
    interest: String,
  },
  data() {
    return {
      callme: {
        name: "",
        email: "",
        phone: "",
      },
      errors: "",
      hasErrors: false,
    }
  },
  methods: {
    submitCallme() {
      console.log("Зашли")
      if (this.callme.email === "" && this.callme.phone === "") {
        this.hasErrors = true
        this.errors = "Необходимо указать номер телефона или email для связи с вами."
        return false
      }
      api
        .post("/api/message", {
          name: this.callme.name,
          email: this.callme.email,
          phone: this.callme.phone,
          subject: "Кнопка заказа",
          interest: this.interest,
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.$bvToast.toast(`Сообщение успешно отправлено. Скоро вы получите ответ от наших менеджеров.`, {
              title: `Сообщение отправлено!`,
              toaster: "b-toaster-top-center",
              variant: "success",
              solid: true,
              appendToast: false,
            })
          } else {
            this.$bvToast.toast(`Ошибка при отправке сообщения, повторите пожалуйста попытку позже.`, {
              title: `Сообщение не отправлено!`,
              toaster: "b-toaster-top-center",
              variant: "danger",
              solid: true,
              appendToast: false,
            })
          }
        })
      this.$bvModal.hide(this.name)
      this.resetForm()
    },
    resetForm() {
      console.log("Reseting the form")
      var self = this //you need this because *this* will refer to Object.keys below`

      //Iterate through each object field, key is name of the object field`
      Object.keys(this.callme).forEach(function (key) {
        self.callme[key] = ""
      })
    },
  },
}
</script>
